import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  tooltip: {
    maxWidth: 496,
    boxSizing: 'border-box',
    position: 'relative',
    fontWeight: idsTokens.typography.font.weight.regular,
  },
  tooltipPlacementLeft: {
    margin: '0 10px !important',
    '@media (min-width:600px)': {
      margin: '0 10px',
    },
  },
  tooltipPlacementRight: {
    margin: '0 12px !important',
    '@media (min-width:600px)': {
      margin: '0 12px',
    },
  },
  tooltipPlacementTop: {
    margin: '11px 0 !important',
    '@media (min-width:600px)': {
      margin: '11px 0',
    },
  },
  tooltipPlacementBottom: {
    margin: '11px 0 !important',
    '@media (min-width:600px)': {
      margin: '11px 0',
    },
  },
  popper: {
    zIndex: 3001,
    '&[data-popper-placement*="bottom"] .MuiTooltip-arrow, &[data-popper-placement*="top"] .MuiTooltip-arrow': {
      height: '0.813rem',
      width: '0.71rem',
    },
    '&[data-popper-placement*="left"] .MuiTooltip-arrow, &[data-popper-placement*="right"] .MuiTooltip-arrow': {
      width: '0.71rem',
      height: '0.813rem',
    },
    '&[data-popper-placement*="top"]': {
      '.MuiTooltip-arrow': {
        marginBottom: '-0.75rem',
        '&:before': {
          transform: 'rotate(0deg)',
        },
      },
    },
    '&[data-popper-placement*="left"] .MuiTooltip-arrow, &[data-popper-placement*="right"] .MuiTooltip-arrow, &[data-popper-placement*="bottom"] .MuiTooltip-arrow': {
      '&:before': {
        transformOrigin: 'center',
      },
    },
    '&[data-popper-placement*="bottom"] .MuiTooltip-arrow': {
      marginTop: '-0.75rem',
      '&:before': {
        transform: 'rotate(180deg)',
      },
    },
    '&[data-popper-placement*="left"] .MuiTooltip-arrow': {
      marginRight: '-0.71rem',
      '&:before': {
        transform: 'rotate(-90deg)',
      },
    },
    '&[data-popper-placement*="right"] .MuiTooltip-arrow': {
      marginLeft: '-0.71rem',
      '&:before': {
        transform: 'rotate(90deg)',
      },
    },
  },
});
